import { makeStyles, Theme } from '@material-ui/core';
import { isDarkTheme } from '../../eliot-components/src/theme';

export const useSelectableDeviceBoxStyles = makeStyles((theme: Theme) => ({
  device: {
    margin: theme.spacing(0, -1, 1, -1),
    padding: theme.spacing(1),
    userSelect: 'none',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 170,
    flexShrink: 0,
    '& .chip-status': {
      display: 'none !important',
    },
    '&.pinned': {
      backgroundColor: isDarkTheme(theme)
        ? theme.palette.primary.dark
        : theme.palette.primary.light,
    },
  },
  selected: {
    background: theme.palette.action.selected,
  },
  selectAll: {
    display: 'flex',
    flexShrink: 0,
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    margin: theme.spacing(1, -1),
    '& .label': {
      flexGrow: 1,
    },
  },
  fvb: {
    display: 'flex',
    flex: '0 0 40%',
    marginRight: '5%',
    whiteSpace: 'nowrap',
    marginTop: theme.spacing(0.5),
    alignItems: 'center',
  },

  field: {
    display: 'inline-block',
    backgroundColor: theme.palette.action.hover,
    minWidth: '50px',
    margin: theme.spacing(0, 1, 0, 0),
    padding: theme.spacing(0.5, 1),
    borderRadius: theme.shape.borderRadius,
    textAlign: 'left',
  },
  value: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  valueLong: {
    minWidth: '220px',
  },

  valueShort: {
    minWidth: '100px',
  },
  health: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  icons: {
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(0.5),
    justifyContent: 'center',
  },
  modelName: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flex: '1 1 auto',
    minWidth: 100,
  },
  headerRow: {
    display: 'flex',
    alignItems: 'center',
  },
  headerContent: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    flex: '1 1 auto',
    minWidth: 0,
    rowGap: theme.spacing(0.5),
  },
  iconsWrapper: {
    flexShrink: 0,
  },
  render: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },
  status: {
    display: 'inline-flex',
    alignItems: 'center',
    '& .current': {
      marginRight: 5,
    },
  },
}));
